import { cn } from '@/utils/cn'
import { type VariantProps, cva } from 'class-variance-authority'
import type { HTMLAttributes } from 'react'

const noteVariants = cva('flex flex-col gap-1 rounded-2xl border px-3 py-2 text-sm', {
  variants: {
    color: {
      blue: 'border-accent bg-accent/10 text-accent',
      green: 'border-success bg-success/10 text-success',
      orange: 'border-warning bg-warning/10 text-warning',
      red: 'border-destructive bg-destructive/10 text-destructive',
    },
  },
  defaultVariants: {
    color: 'blue',
  },
})

interface NoteProps extends Omit<HTMLAttributes<HTMLDivElement>, 'color'>, VariantProps<typeof noteVariants> {}

export function Note({ className, color, ...props }: NoteProps) {
  return <div className={cn(noteVariants({ color }), className)} {...props} />
}
